
import { Component, Vue } from 'vue-property-decorator';
import { ICellRendererParams } from 'ag-grid-community/dist/lib/rendering/cellRenderers/iCellRenderer';

@Component({ components: {} })
export default class TextCellEditor extends Vue {
  value = '';
  params!: ICellRendererParams;
  created() {
    this.value = this.params.value;
  }
  getValue() {
    return this.value;
  }
  onComplete() {
    this.params.api.stopEditing();
  }
}
